module.exports = __webpack_public_path__ + "static/media/pass-white.d8c03048.svg";